import React from "react";

export const NoValue = (): JSX.Element => {
  return <span>-</span>;
};
